import service from '../index';
import config from '@/assets/config.json';

/**
 * @亲子项目订单管理亲子项目订单
 * 
 * @config.babyHttps.api 
*/

const token = localStorage.getItem('Beitoken')

 // 获取订单列表
export function getBabyOrderList(params) {
    const url = config.babyHttps.api + '/apitravel/admin/order/list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

 // 获取订单详情
export function getBabyOrderDetail(params) {
    const url = config.babyHttps.api + '/apitravel/admin/order/info';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

 // 获取订单详情
export function setBabyOrderOption(params) {
    const url = config.babyHttps.api + '/apitravel/admin/order/option';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}
